import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { NotificationService } from '../../../services/notifications.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PropsService } from '../../../services/props.service';
import { paymentBody, IPaymentData } from './create-template.interface';
import { BaseService } from '../../../services/base.service';
import {
  FormArray,
  FormArrayName,
  FormControl,
  FormControlDirective,
  FormGroup,
  isFormControl,
  isFormGroup,
  Validators,
} from '@angular/forms';
import { NovaPoshtaService } from '../../../services/nova-poshta.service';
import { map, Observable, startWith } from 'rxjs';
import { DOLLAR, activeTranslations } from '../../../enum/constants';

interface CreateForm {
  name: FormControl;
  box: FormControl;
  description_product: FormControl;
  price: FormControl;
  params: FormControl;
  global_params: any;
  payer_delivery: FormControl;
  form_payment: FormControl;
  internal_shipment_number: FormControl;
  document: FormControl;
  package_number: FormControl;
  additional_information: FormControl;
  address: FormControl;
  remittance: FormControl;
  remittance_payer_delivery: FormControl;
  contact: FormControl;
  global_weight: FormControl;
  volume_length: FormControl;
  number_seats: FormControl;
  manual: FormControl;
}

@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateTemplateComponent implements OnInit, OnDestroy {
  public isLoader: boolean = false;
  public paymentData: IPaymentData;
  public card = '4028082004159990';
  public cardView = '4028 0820 0415 9990';
  public addresses: any[] = [
    { value: 'steak-0', viewValue: 'Steak' },
    { value: 'pizza-1', viewValue: 'Pizza' },
    { value: 'tacos-2', viewValue: 'Tacos' },
  ];
  public cargos: any[] = [];
  public filteredCargos!: Observable<any[]>;

  public createForm!: FormGroup<CreateForm>;
  public contacts: any[] = [];

  formSubmitted = false;

  constructor(
    private clipboard: Clipboard,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<CreateTemplateComponent>,
    private propsService: PropsService,
    public baseService: BaseService,
    public novaPoshtaService: NovaPoshtaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.paymentData = this.data.data;
  }

  ngOnInit(): void {
    this.loadCargo();
    this.loadUserInfo();

    this.createForm = new FormGroup({
      name: new FormControl('', Validators.required),
      box: new FormControl('1'),
      description_product: new FormControl(''),
      price: new FormControl('1'),
      params: new FormControl(false),
      global_params: new FormArray([
        new FormGroup({
          weight: new FormControl(''),
          length: new FormControl(''),
          width: new FormControl(''),
          height: new FormControl(''),
        }),
      ]),
      payer_delivery: new FormControl('1'),
      form_payment: new FormControl('1'),
      internal_shipment_number: new FormControl(''),
      document: new FormControl(''),
      package_number: new FormControl(''),
      additional_information: new FormControl(''),
      address: new FormControl(''),
      remittance: new FormControl(false),
      remittance_payer_delivery: new FormControl(''),
      contact: new FormControl(''),
      global_weight: new FormControl(''),
      volume_length: new FormControl(''),
      number_seats: new FormControl(''),
      manual: new FormControl(''),
    });
    this.filteredCargos = this.createForm.controls.description_product.valueChanges.pipe(
      startWith(''),
      map((value: string) => this.cargos.filter((fv) => fv.Description.toLowerCase().includes(value.toLowerCase()))),
    );
  }

  ngOnDestroy(): void {}

  copyProps(data: string) {
    this.clipboard.copy(data);
    this.notificationService.showInfo(
      '',
      activeTranslations.notifications_texts.info.copied,
    );
  }

  parsePrice(price: any) {
    return (price * DOLLAR).toFixed();
  }

  confirmAdmin(): void {
    this.isLoader = true;
    const body: paymentBody = {
      payment_code: this.baseService.currentCompanyInfo?.code,
      tariff: this.paymentData.tariff,
      payment_type: 'tariff',
      payment_method: this.paymentData.type,
      price: this.paymentData.price,
    };

    this.propsService.notifyAdmin(body).subscribe(
      () => {
        this.isLoader = false;
        this.notificationService.showInfo(
          activeTranslations.notifications_texts.info.thanks_for_payment,
          '',
        );
        this.dialogRef.close(true);
      },
      (error) => {
        this.isLoader = false;
        console.error('Ошибка при отправке запроса:', error);
      },
    );
  }

  private loadCargo() {
    this.novaPoshtaService
      .postCall({
        apiKey: this.paymentData.api_key,
        modelName: 'Common',
        calledMethod: 'getCargoDescriptionList',
        methodProperties: {
          FindByString: '',
          Page: '1',
        },
      })
      .subscribe((res) => {
        this.cargos = res.data;
      });
  }

  private loadUserInfo() {
    this.novaPoshtaService
      .postCall({
        apiKey: this.paymentData.api_key,
        modelName: 'Counterparty',
        calledMethod: 'getCounterparties',
        methodProperties: {
          CounterpartyProperty: 'Recipient',
          GetPrivatePerson: '1',
        },
      })
      .subscribe((res) => {
        const data = res.data[0];

        this.novaPoshtaService
          .postCall({
            apiKey: this.paymentData.api_key,
            modelName: 'ContactPersonGeneral',
            calledMethod: 'getContactPersonsList',
            methodProperties: {
              ContactProperty: 'Sender',
              CounterpartyRef: data.CounterpartyRef,
              FindByString: '',
              Limit: 200,
              Page: 1,
            },
          })
          .subscribe((res) => {
            this.contacts = res.data;
            if (res.data.length === 1) {
              this.createForm.controls.contact?.setValue(this.contacts[0]);
            }
            this.novaPoshtaService
              .postCall({
                apiKey: this.paymentData.api_key,
                modelName: 'Counterparty',
                calledMethod: 'getCounterpartyContactPersons',
                methodProperties: {
                  Ref: res.data[0].CounterpartyRef,
                  Page: '1',
                },
              })
              .subscribe((res) => {
                this.novaPoshtaService
                  .postCall({
                    apiKey: this.paymentData.api_key,
                    modelName: 'AddressContactPersonGeneral',
                    calledMethod: 'getAddresses',
                    methodProperties: {
                      ContactPersonRef: res.data[0].Ref,
                    },
                  })
                  .subscribe((res) => {
                    this.addresses = res.data[0]?.Warehouses;
                    if (res.data.length === 1) {
                      this.createForm.controls.address?.setValue(this.addresses[0]);
                    }
                  });
              });
          });
      });
  }

  createPlace() {
    const globalParams = this.createForm.controls.global_params as FormArray;
    globalParams.push(
      new FormGroup({
        weight: new FormControl(''),
        length: new FormControl(''),
        width: new FormControl(''),
        height: new FormControl(''),
      }),
    );
  }

  getGlobalParams() {
    return this.createForm.get('global_params') as FormArray;
  }

  copyPlace(event: any) {
    const globalParams = this.createForm.controls.global_params as FormArray;
    globalParams.push(
      new FormGroup({
        weight: new FormControl(event.controls.weight.value),
        length: new FormControl(event.controls.length.value),
        width: new FormControl(event.controls.width.value),
        height: new FormControl(event.controls.height.value),
      }),
    );
  }

  removePlace(index: any) {
    this.getGlobalParams().removeAt(index);
  }

  calcWeight(item?: any) {
    if (item) {
      const weight = item.controls.weight.value;
      const length = item.controls.length.value;
      const width = item.controls.width.value;
      const height = item.controls.height.value;
      const result = (length * width * height) / 4000;
      if (length > 0 && width > 0 && height > 0) {
        return result < 0.1 ? 0.1 : result;
      } else {
        return '-';
      }
    }
    const global_weight = this.createForm.controls.global_weight.value;
    const volume_length = this.createForm.controls.volume_length.value;
    const number_seats = this.createForm.controls.number_seats.value;

    const globalResult = global_weight * volume_length * number_seats * 240;

    if (global_weight > 0 && volume_length > 0 && number_seats > 0) {
      return globalResult < 0.1 ? 0.1 : globalResult;
    }
    return '-';

    return 0;
  }

  manualDisabled(item: any): boolean {
    const weight = item.controls.weight.value;
    const length = item.controls.length.value;
    const width = item.controls.width.value;
    const height = item.controls.height.value;
    const res = this.calcWeight(item);
    const ifWeight = weight && weight <= 30;
    const ifLength = length && length <= 120;
    const ifWidth = width && width <= 120;
    const ifHeight = height && height <= 120;
    const ifRes = res && res !== '-' && res <= 30;
    return ifWeight && ifLength && ifWidth && ifHeight && ifRes;
  }

  cancel() {}

  save() {
    this.formSubmitted = true;
    if (this.createForm.valid) {
      this.dialogRef.close();
    }
  }
}
